<template>
  <div id="app" :class="getTheme">
    <HeaderComponent />
    <router-view />
  </div>
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent";
import { mapGetters } from 'vuex'
export default {
  components: {
    HeaderComponent
  },
  computed: {
    ...mapGetters(['getTheme'])
  },
  mounted() {
    let matched = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if(matched) {
      this.$store.dispatch('setTheme', 'theme-2');
    } else {
      this.$store.dispatch('setTheme', 'theme-1');
    }
  }
};
</script>

<style lang="scss">
@import "~normalize.css/normalize";

:root {
  --font-poppins: "Poppins", Helvetica, Arial, sans-serif;
  --font-noto: "Noto Serif JP", Helvetica, Arial, sans-serif;
  --gutter: 20px;
  --border-radius: 7px;
  --max-width: 1400px;
}

.theme-1 {
  --color-blue: #006fff;
  --color-blue-shadow: 0 3px 15px rgba(0, 111, 255, 0.8);
  --color-black: #121212;
  --color-black-rgba: rgba(27, 25, 25, 1);
  --color-grey: #f2f2f2;
  --color-white: #fff;
  --color-background: #fff;
  --color-text-dark: #121212;
  --color-text-light: rgba(0, 0, 0, 0.5);;
  --color-footer-bg: #fff;
  --color-footer-text: #121212;
  --color-footer-border: #f2f2f2;
  --color-expertise-bg: #ffffff;
}

.theme-2 {
  --color-blue: #006fff;
  --color-blue-shadow: 0 3px 15px rgba(0, 111, 255, 0.8);
  --color-black: #121212;
  --color-black-rgba: rgba(27, 25, 25, 1);
  --color-grey: #000;
  --color-white: #fff;
  --color-background: #121212;
  --color-text-dark: #fff;
  --color-text-light: rgba(255, 255, 255, 0.5);;
  --color-footer-bg: #121212;
  --color-footer-text: #fff;
  --color-footer-border: rgba(255, 255, 255, 0.2);
  --color-expertise-bg: #1c1c1c;
}

*,
html,
body {
  box-sizing: border-box;
}

#app {
  font-family: var(--font-poppins);
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--color-black);
  background: var(--color-background);
  transition: all 0.2s ease-in-out;
}

.header__component,
.intro__component,
.competencies__component,
.communities__component {
  .container__fw {
    display: grid;
    grid-template-columns:
      [full-start] minmax(5vw, 1fr) [container-start] minmax(300px, 1100px)
      [container-end] minmax(5vw, 1fr) [full-end];

    .full {
      grid-column: full;

      &.has__sub-grid {
        display: grid;
        grid-template-columns:
          [full-start] minmax(5vw, 1fr) [container-start] minmax(300px, 1100px)
          [container-end] minmax(5vw, 1fr) [full-end];
      }
    }

    .container {
      grid-column: container;
    }
  }
}
</style>
